import React, { useEffect, useState } from "react";
import M from "materialize-css";
import "../Home/Home.css";
import AutoComplete from "../AutoComplete/AutoComplete";
import lorriLogo from "../Content/LoRRI_screen_zero.png";
import Scheduledemo from "../Scheduledemo";
import globe4 from "../Content/globe4.jpg";
import { Activity, currentRequestTimeStamp, LORRI_BENCHMARK_URL, trackActivity, SHOW_LORRI_BENCHMARK } from "./../Constants";
import classes from "./../Searchtransporters/Searchtransporters.module.css";
import { ENABLE_POPUPS, MAX_NUMBER_OF_SEARCHES, Urls } from "../../Urls";
import ReactGA from "react-ga";
import LaunchSection from "../LaunchSection/LaunchSection";
import IntroSection from "../IntroSection/ModulesCard";
import mixpanel from "mixpanel-browser";
import Companyclasses from "../Companies/Companies.module.css";
import Companies3 from "../Companies/Comapnies3";
import MobileLogos from "../Companies/MobileLogos";
import { NoAccessModal } from "../Searchtransporters/Modal";
import CaseStudySection from "../CaseStudy/CaseStudySection";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import GlobeIcon from "../../Content/images/GlobeIcon";
import LorriInfo from "./LorriInfo";

Activity([
  {
    screen: "Home",
    module: "Home",
    user_activity: "Home page visited",
    timestamp: currentRequestTimeStamp(),
  },
]);

const COOKIE_CONSENT_KEY = "cookieConsent";
const CONSENT_EXPIRY_DAYS = 365;

function getCookieConsent() {
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${COOKIE_CONSENT_KEY}=`));
  return match ? match.split("=")[1] : null;
}

function setCookieConsent(value) {
  const maxAge = CONSENT_EXPIRY_DAYS * 24 * 60 * 60;
  document.cookie = `${COOKIE_CONSENT_KEY}=${value}; max-age=${maxAge}; path=/; SameSite=Lax`;
}

const CookieBanner = ({ onAccept }) => {
  const [isVisible, setIsVisible] = useState(getCookieConsent() === null);

  const handleAccept = () => {
    setCookieConsent("true");
    setIsVisible(false);
    onAccept();
  };

  const handleReject = () => {
    setCookieConsent("false");
    setIsVisible(false);
  };

  return (
    isVisible && (
      <div className="cookie-banner">
        <p>
          We use cookies to enhance your experience. By continuing to browse,
          you agree to our use of cookies.{" "}
          <a
            href={`${Urls.LNTNCUrl}/privacypolicy.html`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn more
          </a>
          {/*  */}
        </p>
        <button onClick={handleAccept} className="accept-btn">
          Accept Cookies
        </button>
        <button onClick={handleReject} className="reject-btn">
          Reject
        </button>
      </div>
    )
  );
};

const Home = (props) => {
  const history = useHistory();
  const [cookiesAccepted, setCookiesAccepted] = useState(
    getCookieConsent() === "true"
  );

  useEffect(() => {
    ReactGA.pageview("Home");
    mixpanel.track(`User has viewed home page`, {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: "home",
      ModuleName: "landing_page",
      ActivityLog: `userViewedHomePage`,
      Data: `None`,
      Definition: `User has viewed home page`,
      ActivityType: "page_view",
    });

    if (cookiesAccepted) {
      mixpanel.track(`User has viewed home page`, {
        ApplicationName: `${Urls.mixpanelappname}`,
        ScreenName: "home",
        ModuleName: "landing_page",
        ActivityLog: `userViewedHomePage`,
        Data: `None`,
        Definition: `User has viewed home page`,
        ActivityType: "page_view",
      });
    }

    let elems = document.querySelectorAll(".parallax");

    // By default if you want to open covid-19 slider
    // window.innerWidth > 600 ? (
    //   document.getElementById('Sliding-modal').style.right = '0')
    //   : (document.getElementById('Sliding-modal').style.right = '0')

    M.Parallax.init(elems);

    let elem_bottom_modal = document.querySelectorAll(".modal");
    M.Modal.init(elem_bottom_modal);

    // load feature discovery
    const elems2 = document.querySelectorAll(".tap-target");
    M.TapTarget.init(elems2, {});
  }, [cookiesAccepted]);

  const [searchInput, setSearchInput] = useState("");
  const [showNoAccess, setShowNoAccess] = useState(false);
  const [isNoAcsessModalClosable, setIsNoAcsessModalClosable] = useState(true);
  const [isSuperUser, setIsSuperUser] = useState(
    sessionStorage.getItem("isEmailExist") === "yes"
  );

  const SearchLocation = (value) => {
    let totalSearches =
      parseInt(sessionStorage.getItem("totalSearches"), 10) || 0;

    if (!totalSearches) {
      sessionStorage.setItem("totalSearches", 0);
    }

    const moveToSearch = () => {
      props.history.push({ pathname: "/searchtransporters", state: value });
      Activity([
        {
          screen: "Home",
          module: "Search Bar",
          user_activity: value,
          timestamp: currentRequestTimeStamp(),
        },
      ]);
      ReactGA.event({
        category: "Home",
        action: `Search Bar`,
      });
      mixpanel.track(`User has searched for a location`, {
        ApplicationName: `${Urls.mixpanelappname}`,
        ScreenName: "home",
        ModuleName: "landing_page",
        ActivityLog: `userSearchedSearchBar`,
        Data: `${value.location_name}`,
        Definition: `User has searched for a location`,
        ActivityType: "event_view",
      });
    };

    if (isSuperUser || totalSearches < MAX_NUMBER_OF_SEARCHES) {
      moveToSearch();
    } else {
      setShowNoAccess(true);
      setIsNoAcsessModalClosable(true);
    }
  };

  const handleClose = () => {
    setShowNoAccess(false);
  };

  return (
    <div>
      <CookieBanner onAccept={() => setCookiesAccepted(true)} />
      <NoAccessModal
        show={showNoAccess && ENABLE_POPUPS}
        isClosable={isNoAcsessModalClosable}
        handleClose={handleClose}
      />
      <section className="first-section">
        <div className={`parallax-container`}>
          <div className={`parallax transparent`}>
            <img alt="img" src={globe4} />
          </div>

          <div className="show-on-lg-screen">
            <div className="logo-div">
              <a
                href={Urls.ClientBaseUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  alt="logo"
                  src={lorriLogo}
                  width={"auto"}
                  height={"190"}
                  // className="logo-img"
                />
              </a>
            </div>

            <div className="custom-autosuggest-container-flex autocomplete-container">
              <AutoComplete
                onSelect={(value) => SearchLocation(value)}
                onChange={(value) => setSearchInput(value)}
                value={searchInput}
                inputClassName="Autosuggest-input"
                placeholder={`Search locations, connect the digital dots!`}
                id="custom-input-suggest-id"
              />
            </div>

            {/* <div className={`${classes["s-stats"]}`}>
              <center>
                <span>
                  <b>750+ Districts</b>
                  <b className={`${classes["s-stats-line"]}`}> | </b>
                </span>
                <span>
                  <b>50,000+ Lanes</b>
                  <b className={`${classes["s-stats-line"]}`}> | </b>
                </span>
                <span>
                  <b>2000+ Transporters</b>
                </span>
              </center>
            </div> */}

            <LorriInfo />

            <div style={{ paddingBottom: "12px" }}>
              <div
                style={{ textAlign: "center" }}
                className={classes.heroButtonContainer}
              >
                <a
                  className=""
                  style={{
                    backgroundColor: "white",
                    fontSize: "13px",
                    border: "1px solid #54af3a",
                    padding: "11px 18px",
                  }}
                  id="discover_more"
                  href={
                    window.location === "/"
                      ? "#schedule-form"
                      : "/#schedule-form"
                  }
                  onClick={() => {
                    Activity([
                      {
                        screen: "Home",
                        module: "Schedule Demo Button",
                        user_activity: "Schedule Demo Button Clicked",
                        timestamp: currentRequestTimeStamp(),
                      },
                    ]);
                    ReactGA.event({
                      category: "Header",
                      action: `Schedule Demo Button Clicked`,
                    });

                    mixpanel.track(`User has clicked on Schedule Demo button`, {
                      ApplicationName: `${Urls.mixpanelappname}`,
                      ScreenName: "home",
                      ModuleName: "landing_page",
                      ActivityLog: `userClickedScheduleDemoButton`,
                      Data: `None`,
                      Definition: `User has clicked on Schedule Demo button`,
                      ActivityType: "event_view",
                    });
                    // setdisplay(true);
                  }}
                  rel="noopener noreferrer"
                >
                  <b style={{ color: "#393185" }}>
                    SCHEDULE MEETING/ DEMO NOW{" "}
                    <i
                      className="material-icons right"
                      style={{ color: "#393185", fontSize: "24px" }}
                    />
                  </b>
                </a>

                <button
                  className={classes.gridButton}
                  onClick={() => history.push("/grid")}
                >
                  <GlobeIcon width={20} color={"white"} />
                  Global Smart Logistics Grid
                </button>
              </div>
            </div>
          </div>

          {/* display set to none when not on mobile */}
          <div className="show-on-mobile">
            <div className="logo-div">
              <a
                href={Urls.ClientBaseUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  alt="img"
                  width="370"
                  height="158"
                  src={lorriLogo}
                  className="logo-img"
                />
              </a>
            </div>
            <div className="custom-autosuggest-container-flex autocomplete-container-mobile">
              <AutoComplete
                onSelect={(value) => SearchLocation(value)}
                onChange={(value) => setSearchInput(value)}
                value={searchInput}
                inputClassName="Autosuggest-input"
                placeholder="Search locations, connect the digital dots!"
                id="custom-input-suggest-id"
              />
            </div>
            {/* <div className={`${classes["s-stats-cont"]}`}>
              <center>
                <span>
                  <b className={`${classes["s-stats"]}`}>750+ Districts</b>
                  <b className={`${classes["s-stats-line"]}`}> | </b>
                </span>
                <span>
                  <b className={`${classes["s-stats"]}`}>50,000+ Lanes</b>
                  <b className={`${classes["s-stats-line"]}`}> | </b>
                </span>
                <span>
                  <b className={`${classes["s-stats"]}`}>2000+ Transporters</b>
                </span>
              </center>
            </div> */}
            <LorriInfo />

            <center>
              <div className={`${classes["s-event"]}`}>
                {SHOW_LORRI_BENCHMARK && (
                <a
                  href={LORRI_BENCHMARK_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${classes["s-pevents"]} btn ${classes.benchmarkBtn} mb-2`}
                  onClick={() => trackActivity(
                    "Header", "LoRRI Benchmark Button", "LoRRI Benchmark Button Clicked",
                    "Header", "userClickedLoRRIBenchmarkButton",
                    { eventName: "User has clicked LoRRI Benchmark button", properties: { ActivityLog: "userClickedLoRRIBenchmarkButton" } }
                  )}
                >
                  LORRI BENCHMARK
                  <span className={classes.NewPill}>NEW</span>
                </a>
                )}
                <a
                  // data-target="modal1"
                  href={
                    window.location === "/"
                      ? "#schedule-form"
                      : "/#schedule-form"
                  }
                  className={`${classes["s-pevents"]} modal-trigger btn header-font-size z-depth-2`}
                  onClick={() => {
                    Activity([
                      {
                        screen: "Header",
                        module: "Schedule Demo Button",
                        user_activity: "Schedule Demo Button Clicked",
                        timestamp: currentRequestTimeStamp(),
                      },
                    ]);
                    ReactGA.event({
                      category: "Header",
                      action: `Schedule Demo Button Clicked`,
                    });
                    mixpanel.track(`User has clicked on Schedule Demo button`, {
                      ApplicationName: `${Urls.mixpanelappname}`,
                      ScreenName: "home",
                      ModuleName: "landing_page",
                      ActivityLog: `userClickedScheduleDemoButton`,
                      Data: `None`,
                      Definition: `User has clicked on Schedule Demo button`,
                      ActivityType: "event_view",
                    });
                  }}
                >
                  <i className="material-icons left">event_available</i>
                  SCHEDULE MEETING/ DEMO NOW
                  <i className="material-icons right">chevron_right</i>
                </a>
                <div
                  className={`${classes.mobileGridBtn} btn-small `}
                  onClick={() => {
                    history.push("/grid");
                  }}
                >
                  <GlobeIcon color="white" />
                  <b>GLOBAL SMART LOGISTICS GRID</b>
                  <div></div>
                </div>
                <a
                  href={Urls.ClientBaseUrl}
                  target="_blank"
                  id="company-login-link"
                  rel="noopener noreferrer"
                  className="waves-effect btn-small"
                  style={{ marginTop: "2%" }}
                  onClick={() => {
                    Activity([
                      {
                        screen: "Header",
                        module: "Header",
                        user_activity: "Manufacturer Login Button Clicked",
                        timestamp: currentRequestTimeStamp(),
                      },
                    ]);
                    ReactGA.event({
                      category: "Header",
                      action: `Manufacturer Login Button Clicked`,
                    });

                    mixpanel.track(
                      `User has clicked on Manufacturer Login button`,
                      {
                        ApplicationName: `${Urls.mixpanelappname}`,
                        ScreenName: "home",
                        ModuleName: "header_element",
                        ActivityLog: `userClickedManufacturerLoginButton`,
                        Data: `None`,
                        Definition: `User has clicked on Manufacturer Login button`,
                        ActivityType: "event_view",
                      }
                    );
                  }}
                >
                  <i className="material-icons left">person</i>
                  <b>Manufacturer Login</b>
                </a>
                <a
                  href={Urls.TPMPBaseUrl}
                  target="_blank"
                  id="company-login-link"
                  rel="noopener noreferrer"
                  className="waves-effect btn-small"
                  style={{ marginTop: "2%" }}
                  onClick={() => {
                    Activity([
                      {
                        screen: "Header",
                        module: "Header",
                        user_activity: "Transporter Login Button Clicked",
                        timestamp: currentRequestTimeStamp(),
                      },
                    ]);
                    ReactGA.event({
                      category: "Header",
                      action: `Transporter Login Button Clicked`,
                    });

                    mixpanel.track(
                      `User has clicked on Transporter/LSP Login button`,
                      {
                        ApplicationName: `${Urls.mixpanelappname}`,
                        ScreenName: "home",
                        ModuleName: "header_element",
                        ActivityLog: `userClickedTransporterLoginButton`,
                        Data: `None`,
                        Definition: `User has clicked on Transporter/LSP Login button`,
                        ActivityType: "event_view",
                      }
                    );
                  }}
                >
                  <i className="material-icons left">local_shipping</i>
                  <b>Transporter Login</b>
                </a>
              </div>
            </center>
          </div>
        </div>
      </section>

      <section
        className={`carousel-section ${Companyclasses["show-on-lg-screen"]}`}
      >
        <Companies3 />
      </section>

      <section className={Companyclasses["show-on-mobile"]}>
        <MobileLogos />
      </section>

      <hr />

      <section className="carousel-section">
        <IntroSection />
      </section>
      <hr />

      <div>
        <CaseStudySection />
      </div>
      <hr />

      <section className="launch-section">
        <LaunchSection />
      </section>

      <div
        className="schedule-section"
        style={{ justifyContent: "center", width: "100%", textAlign: "center" }}
      >
        <div className="schedule-time">
          <Scheduledemo setIsSuperUser={setIsSuperUser} />
        </div>
      </div>
    </div>
  );
};
export default Home;
